import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTwitter = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.313 6.375a10.575 10.575 0 0 1-2.532 2.61 14.334 14.334 0 0 1-.578 4.71 14.651 14.651 0 0 1-1.805 3.883 15.262 15.262 0 0 1-2.882 3.29c-1.115.952-2.459 1.713-4.032 2.28-1.572.568-3.255.852-5.046.852-2.823 0-5.407-.755-7.75-2.266.364.042.77.063 1.218.063 2.344 0 4.433-.719 6.266-2.156a4.92 4.92 0 0 1-2.938-1.008 4.936 4.936 0 0 1-1.78-2.492c.343.052.66.078.952.078.448 0 .89-.058 1.328-.172a4.965 4.965 0 0 1-2.898-1.742c-.766-.922-1.148-1.992-1.148-3.211v-.063c.708.396 1.468.61 2.28.64a5.042 5.042 0 0 1-1.64-1.796 4.918 4.918 0 0 1-.61-2.406c0-.917.23-1.766.688-2.547a14.307 14.307 0 0 0 4.602 3.726 14.062 14.062 0 0 0 5.805 1.555 5.608 5.608 0 0 1-.126-1.156c0-1.396.493-2.586 1.477-3.57C16.148 4.492 17.34 4 18.734 4c1.459 0 2.688.531 3.688 1.594a9.896 9.896 0 0 0 3.203-1.219C25.24 5.573 24.5 6.5 23.406 7.156a10.055 10.055 0 0 0 2.907-.781z" />
  </svg>
);
export default SvgTwitter;
